import { IconProps } from "types/icon"

/** `size` = logo height in px */
const Visa = ({ size = "16", ...props }: IconProps) => {
  const height = Number(size)
  const width = height * (48 / 16)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 16"
      fill="none"
      aria-hidden
      {...props}
    >
      <rect width="48" height="16" rx="2.5" fill="#1434CB" />
      <text
        x="24"
        y="11.5"
        textAnchor="middle"
        fill="#FFFFFF"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="9"
        fontWeight="700"
        fontStyle="italic"
        letterSpacing="0.6"
      >
        VISA
      </text>
    </svg>
  )
}

export default Visa
